module.exports = __webpack_public_path__ + "img/header_new.ee3f42a0.png";